import { css } from 'styled-components';
import { responsiveInterpolate } from './responsiveInterpolate';

export const textEllipsis = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const dropShadow = `box-shadow: 0 1px 10px 0 rgba(92, 119, 131, 0.15)`;

export const dropShadowTop = `box-shadow: 0 -1px 10px 0 rgba(92, 119, 131, 0.15)`;

export const MAX_PAGE_CONTENT_WIDTH = 1170;

export const DESKTOP_VERTICAL_PADDING = 124;

export const MOBILE_VERTICAL_PADDING = 56;

export const DESKTOP_HEADER_PADDING = 40;

export const MOBILE_PADDING = 16;

export const PAGE_SIDE_PADDING = `max(16px, (100vw - ${MAX_PAGE_CONTENT_WIDTH}px) / 2)`;

export const PAGE_CONTAINER = css`
  box-sizing: border-box;
  padding-left: ${PAGE_SIDE_PADDING};
  padding-right: ${PAGE_SIDE_PADDING};
  width: 100%;
`;

export const HEADER_CONTAINER = css`
  box-sizing: border-box;
  padding: 0 ${responsiveInterpolate(16, 24)};
`;

export const WRAP_LONG_WORDS = css`
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const BORDER_BOX_SIZING = css`
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;
